import { Component, ElementRef, Output, OnDestroy, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '../../../../services/settings.service';
import { RatingService } from '../../../../services/rating.service';
import { PersonService } from '../../../../services/person.service';
import { teamMoodsViews } from '../team-mood.component';
import { SprintService } from '../../../../services/sprint.service';
import { Sprint } from '../../../../models/sprint';

@Component({
  selector: 'app-team-mood-feedback',
  templateUrl: './team-mood-feedback.component.html',
  styleUrls: ['./team-mood-feedback.component.scss']
  })

export class TeamMoodFeedbackComponent implements OnInit, OnDestroy {
  @ViewChild('divcontainer', { static: true }) private element: ElementRef;
  @Output() navigate = new EventEmitter<teamMoodsViews>();
  private project_key: string;
  private event: Subscription[] = [];
  public feedback: any[] = [];
  public sprints: Sprint[] = [];
  public selectedSprintId = '';
  public showFeedback = false;

  public displayedPerson: string;

  constructor(private translate: TranslateService,
    private settingsService: SettingsService,
    private ratingService: RatingService,
    private sprintService: SprintService,
    private personService: PersonService) {
  }

  ngOnInit() {
    this.event.push(this.settingsService.getUpdateObservable().subscribe(() => {
      this.setup();
    }));
    this.setup();
    this.translate.onLangChange.subscribe(res => {
      if (this.ratingService.getSelectedPerson() === 'all') {
        this.displayedPerson = this.translate.instant('widgets.teamMood.wholeTeam');
      } else if (this.ratingService.getSelectedPerson() === 'anonym') {
        this.displayedPerson = this.translate.instant('widgets.teamMood.anonym');
      }
    });
    document.getElementById('navigationFeedbackLeft').addEventListener('click', () => {
      this.navigateToTrent();
    });
  }

  navigateToVoting() {
    this.navigate.emit(teamMoodsViews.showTimeRange);
  }

  navigateToTrent() {
    this.navigate.emit(teamMoodsViews.showTrends);
  }

  ngOnDestroy(): void {
    for (const ev of this.event) {
      ev.unsubscribe();
    }
  }

  setup() {
    this.project_key = this.settingsService.getProjectName();
    this.selectedSprintId = this.settingsService.getSprintId(this.project_key).toString();
    this.displayedPerson = this.ratingService.getDisplayedPerson();
    this.sprintService.getSprints(this.project_key).subscribe(sprints => {
      this.sprints = sprints;
    });
    this.loadData();
    this.ratingService.newVoteObservable.subscribe(() => {
      this.loadData();
    });
    this.ratingService.voteSettingsChangedObservable.subscribe(() => {
      this.loadData();
    });
    this.event.push(this.ratingService.updateSelectedProps.subscribe(reload => {
      if (reload) {
        this.loadData();
      }
    }));
  }

  loadData() {
    console.log('team-mood-feedback. load data.');
    this.showFeedback = false;
    this.ratingService.getFeedbackSprint(this.project_key,
      this.selectedSprintId,
      this.ratingService.getSelectedPerson(),
      this.ratingService.getSelectedStartDate(),
      this.ratingService.getSelectedEndDate()).subscribe(feedbackSprintData => {
      this.feedback = feedbackSprintData;
      this.feedback.sort((a, b) => (<Date>b['date']).getTime() - (<Date>a['date']).getTime());

      this.personService.getMembers(this.project_key).subscribe(team => {
        this.feedback.forEach(element => {
          element['avatarImage'] = team.find(h => h.id === element.person)?.avatarImage;
          element['personName'] = team.find(h => h.id === element.person)?.displayName;
        });
      });
      this.showFeedback = true;
    });
  }

  onSelectedSprintChanged() {
    this.loadData();
  }
}
